module.exports = __webpack_public_path__ + "img/cg.659c5e12.svg";